<template>       
    <div class="userInfo" >
        <!-- top_menu --->
        <div class="top_menu">
            <div class="btn_close" @click="closeMenu()">닫기</div>
            <div>

            </div>
        </div>

        <!-- cont_part --->
        <div class="cont_part">

        <div class="profile"> 
            <!-- profileImg --->            
            <div class="profileImg" >
            <div class="img" v-if="data.userinfo.profile_photo_path"
            :style="{backgroundImage:`url(${data.userinfo.profile_photo_url})`}"
            >
                <div v-if="data.isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
                <div v-if="getManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
            </div>
            <div class="img" v-else
                :style="{backgroundImage:`url(${require('@/assets/imgs/profile_blank.jpg')})`}"
            >
                <div v-if="data.isOwner" class="mark"><img src="@/assets/imgs/chat/owner.gif"></div>
                <div v-if="getManager" class="mark"><img src="@/assets/imgs/chat/manager.gif"></div>
            </div>
            </div>  
            
            <!-- userName --->    
            <div class="userName" >
            <span class="nick">                  
                <span v-if="data.userinfo.level >=0 " class="level_icon">                   
                <template v-if="data.userinfo.role==='user'">                      
                    <img :src="`${require('@/assets/imgs/level/'+data.userinfo.level+'.png')}`">                      
                </template>
                <template v-if="data.userinfo.role==='admin' || data.userinfo.role==='manager'">
                    <img :src="`${require('@/assets/imgs/level/m.png')}`"> 
                </template>                    
                </span> {{data.userinfo.nic?data.userinfo.nic:data.userinfo.from}}  
            </span>           
            </div>
        </div>         
       
        <!-- chat_manage --->    
        <div class="chat_manage" v-if="(data.owner || data.manager) && currentUser.id !== data.userinfo.id">
            <div class="forcedOut" :class="{OnforcedOut:isForceOut}" @click="forcedOut()"> {{ switchForceOut }}</div>
            <div class="addManager" :class="{OnManager:isManager}" @click="addManager()"> {{ switchManager }}</div>
        </div>
        
        <!-- menu --->        
            <template v-if="currentUser.id !== data.userinfo.id">
            <div class="user_menu">
                <div @click="popMessage(data.userinfo.nic?data.userinfo.nic:data.userinfo.from)">
                <span class="menu_ico message"></span>
                <span class="menu_txt" >쪽지</span>
                </div>
                <div @click="addFriend(data.userinfo.nic?data.userinfo.nic:data.userinfo.from,'isMobile')">
                <span class="menu_ico add_friend"></span>
                <span class="menu_txt" >친구추가</span>
                </div>
                <div @click="request_mtmchat()">
                <span class="menu_ico mtm_chat"></span>
                <span class="menu_txt" >1:1채팅</span>
                </div>
            </div>  
            </template>
            <template v-else>
            <div class="user_menu disabled">
                <div>
                <span class="menu_ico message"></span>
                <span class="menu_txt" >쪽지</span>
                </div>
                <div>
                <span class="menu_ico add_friend"></span>
                <span class="menu_txt" >친구추가</span>
                </div>
                <div>
                <span class="menu_ico mtm_chat"></span>
                <span class="menu_txt" >1:1채팅</span>
                </div>
            </div>  
            </template>
        </div>    
    </div>   
    
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import io from "socket.io-client";

export default {
    name:'',
    props:[
        'data'    
    ],
    data(){
        return{            
          socket: io(this.$store.state.serverDomain + ":3000"),   
          isManager:false,
          isForceOut:false,         
        }
    },
    mixins:[
        auth   
    ],
    components:{
              
    },
    mounted() {
      if(this.data.roominfo && this.data.roominfo.manager.find((manager)=>manager.user_id === this.data.userinfo.id))
      {
        this.isManager = true;
      }
      
      if(this.data.roominfo && this.data.roominfo.ban.find((ban)=>ban.user_id === this.data.userinfo.id))
      {
        this.isForceOut = true;
      }
    }, 
    updated(){           
       
    }, 
    computed:{
      // isOwner(){
      //   if(this.data.roominfo && this.data.roominfo.user_id === this.data.userinfo.id)           
      //   {
      //     return true;
      //   }else{
      //     return false;
      //   }
      // },
      // isManager(){
      //   if(this.data.roominfo && this.data.roominfo.manager.find((manager)=>manager.user_id === this.data.userinfo.id))
      //   {
      //     return true;
      //   }else{
      //     return false;
      //   }
      // },
      // isForceOut()
      // {
      //   if(this.data.roominfo && this.data.roominfo.ban.find((ban)=>ban.user_id === this.data.userinfo.id))
      //   {
      //     return true;
      //   }else{
      //     return false;
      //   }
      // },
      getManager(){
        return this.isManager;
      },     
      currentUser(){
        return this.$store.getters.currentUser;
      },  
      switchManager() {
        if (this.isManager) {
            return "매니저 제외";
        } else {
            return "매니저 등록";
        }
      },
      switchForceOut() {
        if (this.isForceOut) {
            return "강퇴 해제";
        } else {
            return "강퇴처리";
        }
      },  
      getNic(){
        if(this.data.userinfo.nic)
        {
          return this.data.userinfo.nic;
        }else{
          return this.data.userinfo.from 
        }
      }   
    },
   
    methods:{
        closeMenu(){           
          this.$emit('close-user-info');          
        },      
        async addManager()
        {
            if(this.data.userinfo.id ==0)
            {
                alert('비회원입니다.');
                return;
            }
            try {
                const response = await this.$store.dispatch("chat/addManager", {user_id: this.data.userinfo.id,owner_id:this.data.roominfo.user_id});
                console.log(response);

                this.$flashMessage.show({
                    type: response.status_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });

                this.isManager = !this.isManager;
                //상태 변경 알림
                let params = {
                    room_id: this.data.roominfo.id,
                    description:'매니저 변경'
                }
                this.socket.emit("UpdateRoom", params, function (callback) {
                    console.log(callback);
                });
            }catch(error){
                console.log(error);
                    this.$flashMessage.show({
                    type: "error",
                    title: error,
                    message: error,
                });
            }
        },
        async forcedOut()
        {

          try {
            const response = await this.$store.dispatch("chat/forcedOut", {user_id: this.data.userinfo.id,owner_id:this.data.roominfo.user_id});
            console.log(response);

            this.$flashMessage.show({
                type: response.status_code===201?"info":"error",
                title: response.message,
                message: response.message,
            });
            this.isForceOut = !this.isForceOut;

            let ment = ' 강퇴 되었습니다.'
            if(!this.isForceOut)
            {
              ment = " 강퇴에서 해제 되었습니다." 
            }

            //상태 변경 알림
            let params = {
                room_id:this.data.roominfo.id,
                description: this.getNic + ment,
                ban:response.user_ban,
                user_id:this.data.userinfo.id,
                type:'forcedout'
            }
            this.socket.emit("UpdateRoom", params, function (callback) {
              console.log(callback);
            });

          }catch(error){
            console.log(error);
            this.$flashMessage.show({
                type: "error",
                title: error,
                message: error,
            });
          }
        },
        async request_mtmchat(){
            //this.$emit('request-mtm')

            //console.log('1대1대화 신청',this.userinfo.socketid);
            //console.log(this.$store.getters.currentuserinfo.nic);
            //alert(this.userinfo.id);
            // alert('준비중입니다.');
            // return;
            
            if(this.data.userinfo.id ==0)
            {
                alert('비회원으로 조회가 불가능 합니다.');
                return;
            }
            //아이템 판단
            //아이템 유무 확인 있으면 사용유무를 묻고 없으면 구매유무를 확인한다.
            //방장과 매니저는 참여자에게 1:1채팅 신청 무료
            //현재 유저가 방장이나 매니져인지 확인
            let ckitem = true;
            if( !this.data.roominfo || (!this.data.owner && !this.data.manager) )
            {
              ckitem =  await this.ckItem('chat_mtm','pop','','1:1 채팅 이용권');
            }
            if(!ckitem){
                return;
            }else{
                //아이템이 있을시
                let params = {
                    fromNic: this.currentUser.nic,
                    fromId: this.currentUser.id,
                    tosocketid:this.data.userinfo.socketid,
                    toNic:this.getNic,
                    room:'mtm_'+this.currentUser.id+'_'+this.data.userinfo.id
                };
                this.socket.emit("requestMtm", params, function (callback) {
                    if (callback==="success") {

                    //const url="/chat/mtm/"+params.room;
                        //newPop('mtm_'+params.room,url,'','',500,400);
                      this.mtm_chat = true;                      
                    }else{
                        alert(callback);
                      return  
                    }
                });
              //채팅 신청 하고 채팅방 진입
              //1:1 채팅방 저장

              this.$store.commit('sets/addMtmJoin',{room:params.room,nic:params.toNic});
              this.$emit('mtm-chat-join',params.room);  

              this.closeMenu();
              
            }
            
        },       
    }
}
</script>
<style lang="scss" scoped>
.userInfo{
  background:url(../../../assets/imgs/bg/bg_profile.jpg) top center #fff;  
  width:100%;
  height: 100vh;
  
  display: flex;
  flex-direction: column;   
  z-index: 99; 
  .top_menu{
    display: flex;
    justify-content: space-between;
    padding:20px;
    .btn_close{
      display: inline-block;
      cursor: pointer;
      width:19px;
      height:19px;
      background-image:url(../../../assets/imgs/sign.png);
      background-position: -81px 0;
      background-size: 150px auto;
      text-indent: -9999px;   
    }
  }  
  .cont_part{
    height: calc( 100vh - 100px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction:column;

    .profile{
      color:#fff;
     .profileImg {
        width: 100px;
        height: 100px;        
        .img {
          background-color: #000;
          width: 100%;
          height: 100%;
          background-size:cover;
          border-radius: 10px;
          border:2px solid rgb(91, 124, 185);
        }
        .mark{
          padding-top: 10px;          
        }
      }

      .userName { 
        display: flex;
        justify-content: center;     
        font-size: 12px; 
        margin:10px 0;          
        .nick{        
          .level_icon{
          img{
            vertical-align: middle;
            width:20px;
          }
          }
        }
      }
    }

    .chat_manage{
      margin-top:50px;
      color:#fff;
      display: flex;
      padding:10px;
      width:90%;
      div{
        padding:5px 0;
        width:50%;
        text-align: center;
        margin:2px;
      }
      .forcedOut{
        border:2px solid #ed145b;
        border-radius: 5px;
      }
      .OnforcedOut{
        background: #f12aa5;
      }
      .addManager{
        border:2px solid #0072bc;
        border-radius: 5px;
      }
      .OnManager{
        background: #0787ff;
      }
    }
    .disabled{
      .menu_ico{
        opacity:0.2;
      }
      .menu_txt{
        color:#363636 !important;
      } 
    }
    .user_menu{
      border-top: 1px solid #363636;      
      width:90%;
      display: flex;
      justify-content: space-evenly;
      color:#fff;      
      margin-bottom:50px;
      div{
        display: flex;
        align-items: center;
        flex-direction:column;
        .menu_ico{
          display: inline-block;
          width:100px;
          height:100px;   
          background-position: 0 0;
          
        }
        .message{               
          background-image:url(../../../assets/imgs/icon/m_icon_message.png);               
        } 
        .add_friend{               
          background-image:url(../../../assets/imgs/icon/m_icon_friends2.png);               
        } 
        .mtm_chat{               
          background-image:url(../../../assets/imgs/icon/m_icon_mtm.png);               
        } 
        .menu_txt{
          margin-top:-15px;
        }
      }
    }

    

  } 
}
</style>